// Fuente única de las etiquetas de plan mostradas en el frontend — los
// precios/límites reales viven en backend/server.py (PLAN_PRICES_MXN etc.),
// esto es solo para no repetir el mismo objeto de etiquetas en cada página.
export const PLAN_LABELS = { starter: "Starter", growth: "Growth", pro: "Pro", enterprise: "Enterprise" };
